const API = process.env.REACT_APP_BACKEND_URL;
const BASE = `${API}/api/notaria`;
let _csrf = null;
async function req(path, { method = 'GET', body } = {}) {
  const headers = { 'Content-Type': 'application/json' };
  if (method !== 'GET' && _csrf) headers['X-CSRF-Token'] = _csrf;
  const res = await fetch(`${BASE}${path}`, {
    method,
    headers,
    credentials: 'include',
    body: body ? JSON.stringify(body) : undefined,
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const err = new Error(data.detail || `Error ${res.status}`);
    err.status = res.status;
    throw err;
  }
  return data;
}
export const api = {
  // Identidad por llave (reto Ed25519). Sin correo ni terceros.
  keyChallenge: (pub_b64) => req('/auth/key/challenge', { method: 'POST', body: { pub_b64 } }),
  keyVerify: async (pub_b64, nonce, sig_b64) => {
    const d = await req('/auth/key/verify', { method: 'POST', body: { pub_b64, nonce, sig_b64 } });
    if (d.csrf_token) _csrf = d.csrf_token;
    return d;
  },
  me: async () => {
    const d = await req('/auth/me');
    if (d.authenticated === false) return null;
    if (d.csrf_token) _csrf = d.csrf_token;
    return d;
  },
  logout: async () => {
    const d = await req('/auth/logout', { method: 'POST' });
    _csrf = null;
    Object.keys(localStorage).filter((k) => k.startsWith('nt_e2e') || k.startsWith('nt_sig')).forEach((k) => localStorage.removeItem(k));
    return d;
  },
  listAgreements: () => req('/agreements'),
  createAgreement: (payload) => req('/agreements', { method: 'POST', body: payload }),
  getAgreement: (id) => req(`/agreements/${id}`),
  join: (id, invite_token) => req(`/agreements/${id}/join`, { method: 'POST', body: { invite_token } }),
  sign: (id) => req(`/agreements/${id}/sign`, { method: 'POST' }),
  getMessages: (id) => req(`/agreements/${id}/messages`),
  chainTip: (id) => req(`/agreements/${id}/chain_tip`),
  postMessage: (id, ct, iv, extra) => req(`/agreements/${id}/messages`, { method: 'POST', body: { ct, iv, ...(extra || {}) } }),
  publishSigKey: (id, ed25519_pub_b64) => req(`/agreements/${id}/sig_key`, { method: 'POST', body: { ed25519_pub_b64 } }),
  getSigKeys: (id) => req(`/agreements/${id}/sig_keys`),
  publishE2EKey: (id, public_key_jwk) => req(`/agreements/${id}/e2e_key`, { method: 'POST', body: { public_key_jwk } }),
  getE2EKeys: (id) => req(`/agreements/${id}/e2e_keys`),
  publishE2EPQKey: (id, body) => req(`/agreements/${id}/e2e_pq_key`, { method: 'POST', body }),
  getE2EPQKeys: (id) => req(`/agreements/${id}/e2e_pq_keys`),
  refreshOts: (id) => req(`/agreements/${id}/ots/refresh`, { method: 'POST' }),
  verify: (hash) => req('/verify', { method: 'POST', body: { hash } }),
  publicProof: (id) => req(`/public/${id}`),
  paymentStatus: (id) => req(`/agreements/${id}/payment_status`),
  certUrl: (id) => `${BASE}/certificate/${id}.pdf`,
  bundleUrl: (id) => `${BASE}/proof/${id}.zip`,
  otsUrl: (id) => `${BASE}/proof/${id}.ots`,
  proofJsonUrl: (id) => `${BASE}/proof/${id}.json`,
  shareUrl: (id) => `${BASE}/p/${id}`,
};
// Ir a la pantalla de entrada propia (identidad por llave).
export function goLogin(returnPath = '/panel') {
  window.location.href = `/entrar?next=${encodeURIComponent(returnPath)}`;
}
// Flujo web: SHA-256 en el navegador; el archivo no se envía a este endpoint.
export async function sha256Hex(bufferOrString) {
  const data = typeof bufferOrString === 'string'
    ? new TextEncoder().encode(bufferOrString)
    : bufferOrString;
  const digest = await crypto.subtle.digest('SHA-256', data);
  return Array.from(new Uint8Array(digest)).map((b) => b.toString(16).padStart(2, '0')).join('');
}
export async function sha256File(file) {
  const buf = await file.arrayBuffer();
  return sha256Hex(buf);
}
